import { render } from "./SearchPage.vue?vue&type=template&id=b2a4c798&scoped=true"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"

import "./SearchPage.vue?vue&type=style&index=0&id=b2a4c798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a4c798"]])

export default __exports__